module.exports = __webpack_public_path__ + "img/unarchive.17299dc6.svg";